import { render, staticRenderFns } from "./price-vat-tip.vue?vue&type=template&id=b6139868"
import script from "./price-vat-tip.vue?vue&type=script&lang=js"
export * from "./price-vat-tip.vue?vue&type=script&lang=js"
import style0 from "./price-vat-tip.vue?vue&type=style&index=0&id=b6139868&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports